import React from "react";
import styled from "styled-components";

const Paragraph = styled.p`
  margin-bottom: 0;
  font-size: 19px;
  @media (max-width: 767px) { font-size: 17px; }
  font-weight: 300;
  letter-spacing: -0.66px;
  line-height: 38px;
`;

const ParagraphSmall = styled(Paragraph)`
  font-size: 14px;
  @media (max-width: 767px) { font-size: 12px; }
  letter-spacing: -0.5px;
  line-height: 28px;
`;

const Text = ({ variant, ...props }) => {
  let TextRender;

  switch (variant) {
    case "small":
      TextRender = ParagraphSmall;
      break;
    default:
      TextRender = Paragraph;
  }

  return <TextRender color="text" {...props} />;
};

export default Text;
